import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";
import AdminBatchSections from "./AdminBatchSections";

  import { useRouteMatch,Switch, Route } from "react-router-dom";
  import { useHistory,} from "react-router-dom";
import { Pencil } from "lucide-react";
export default function AdminBatchDashboardCard({
  
  
  onEdit
}) {

      const {url}=useRouteMatch();
   const history = useHistory();
 
    const {batchId} = useParams();
  const [batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(false);


const domain = useSelector((state)=>state?.app?.app?.domain);
      const coursePostId = useSelector((state)=>state?.course?.course?.postId);
        const currentToken = useSelector((state)=>state?.user?.user?.token);
             const userEmail = useSelector((state)=>state?.user?.user?.user_email);
    
       const AppToken = useSelector((state)=>state?.app?.app?.AppToken);

  useEffect(() => {
    if (!batchId) return;
    load();
  }, [batchId]);

  async function load() {
    setLoading(true);
    try {
      const res = await axios.get(`${webUrlNode}/api/batches/${batchId}?appToken=${AppToken}`, {
       params: {
         
          coursePostId,
          userEmail,
          currentToken
          
        }
      });

      setBatch(res.data.item);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <div style={{ padding: 12 }}>Loading batch…</div>;
  }

  if (!batch) return null;

  return (<div>
    <div
      style={{
        border: "3px dashed rgba(144, 202, 249,1)",
        borderRadius: 8,
        padding: 14,
        marginBottom: 16
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12
        }}
      >
        <div>

          <div style={{ fontSize: 18, fontWeight: 600 }}>
            {batch.batchName}
          </div>

          <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
            {batch.mode} • {batch.enrollmentStatus} • {batch.visibility}
          </div>

        </div>

        <div>
          <button style={{width:"120px",position:"relative",fontSize:"14px",background:"rgb(249, 201, 199)",color:"#222",
        padding:"5px 10px" ,borderRadius:"5px",cursor:"pointer",zIndex:"9",border:"2px solid #ffffff",display:"flex",justifyContent:"space-between",alignItems:"center"}} 
        onClick={onEdit}>
          <Pencil size={16} color={"rgb(44, 44, 44)"}/> <span>Edit batch</span> 
          </button>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(140px,1fr))",
          gap: 12,
          marginTop: 14,
          fontSize: 13
        }}
      >
        <InfoItem
          label="Start"
          value={formatDate(batch.startDate)}
        />

        <InfoItem
          label="End"
          value={formatDate(batch.endDate)}
        />

        <InfoItem
          label="Timezone"
          value={batch.timezone || "—"}
        />

        <InfoItem
          label="Max students"
          value={batch.maxStudents ?? "—"}
        />

        <InfoItem
          label="Price"
          value={`₹ ${batch.price ?? 0}`}
        />

        <InfoItem
          label="Created"
          value={formatDate(batch.createdAt)}
        />
      </div></div>
      <AdminBatchSections 
      
      onAddContent={(v)=>{ if(v=="addContentRoute"){ history.push(`${url}/content-drip`);} }}
  onShowAllContent={(v=>{})}

  onAddHomework={(v)=>{history.push(`${url}/batch-homeworks`); }}
  onShowAllHomework={(v)=>{}}

  onAddSession={(v)=>{}}
  onShowAllSessions={(v)=>{}}
onEnrollStudent={(v)=>{  history.push(`${url}/batch-students`);}}
  onShowStudents={(v)=>{}} />
    </div>
  );
}

/* ---------------- helpers ---------------- */

function InfoItem({ label, value }) {
  return (
    <div>
      <div style={{ color: "#777", fontSize: 11 }}>
        {label}
      </div>
      <div style={{ fontWeight: 500 }}>
        {value}
      </div>
    </div>
  );
}

function formatDate(v) {
  if (!v) return "—";
  return new Date(v).toLocaleString();
}
